<template>
	<section id="user" class="slideDown" >

    <div class="back" @click="back()">{{ $t('user.back') }}</div>

    <div class="container">
      <div class="content">

        <h3 class="title"><span v-if="user.id == -1">{{ $t('general.create') }}</span><span v-else>{{ $t('general.edit') }}</span
          ><span>{{ $t('user.user') }}</span>
        </h3>

        <div class="details">

          <div class="subtitle">{{ $t('general.subtitle') }}</div>
          <v-form ref="form_user" v-model="valid">
              <div class="alert">{{ $t('user.alert') }}</div>
              
              <v-text-field v-model="user.name" :rules="nameRules" :label="$t('general.name')" required></v-text-field>
              <v-text-field v-model="user.email" :rules="emailRules" :label="$t('general.email')" required></v-text-field>
              <!-- <v-text-field v-model="user.phone" :rules="phoneRules" label="Teléfono"></v-text-field> -->
              <!-- <v-text-field v-model="user.username" :rules="nameRules" label="Nombre de usuario" required></v-text-field> -->
              <!-- <v-text-field v-if="user.id == -1" :type="'password'" v-model="user.password" required label="Contraseña"></v-text-field> -->
              <!-- <v-text-field v-else v-model="user.password" :type="'password'" label="Definir una nueva contraseña"></v-text-field> -->
              <v-select v-model="user.type" :items="types" :label="$t('general.role')" item-text="text" item-value="value" required></v-select>
              <v-switch v-model="user.active" :label="$t('general.active')"></v-switch>
          </v-form>
          
          <div class="clear" style="height: 50px"></div>
          <div class="subtitle">{{ $t('user.restaurants') }}</div>
          <div>
            <v-card-title>
                
                <v-spacer></v-spacer>
                <v-text-field  v-model="search" append-icon="search" :label="$t('user.search_restaurant')" single-line hide-details></v-text-field>
            </v-card-title>
            <v-data-table :custom-filter="filterTable" v-model="selected" :headers="headers" :items="restaurants" class="elevation-1" :no-results-text="message_not_found" :rows-per-page-items="rowsPerPage" :search="search" :pagination.sync="pagination" select-all :rows-per-page-text="message_rows_per_page">
                <!-- <template v-slot:headers="props">
                  <tr>
                    <th>
                      <v-checkbox :input-value="props.all" :indeterminate="props.indeterminate" primary hide-details @click.stop="toggleAll" ></v-checkbox>
                    </th>
                    <th
                      v-for="header in props.headers"
                      :key="header.text"
                      :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                      @click="changeSort(header.value)"
                    >
                      <v-icon small>arrow_upward</v-icon>
                      {{ header.text }}
                    </th>
                  </tr>
                </template> -->
                <template v-slot:items="props">
                  <tr :active="props.selected" @click="props.selected = !props.selected">
                    <td><v-checkbox :input-value="props.selected" primary hide-details :key="props.item.id"></v-checkbox></td>
                    <!-- <td><v-checkbox v-model="props.selected" primary hide-details :key="props.item.id"></v-checkbox></td> -->
                    <td>{{ props.item.site }} - {{ props.item.name }}</td>
                    <td>{{ regions[props.item.region].name }}</td>
                  </tr>
                </template>
            </v-data-table>
          </div>

        </div>


        <div class="buttons">
          <v-btn color="success" @click="save">{{ $t('general.save') }}</v-btn>
          <v-btn color="cancel" @click="back">{{ $t('general.back') }}</v-btn>
        </div>

      </div>
    </div>
   
	</section>
</template>

<script>
import i18n from "@/i18n";
export default {
  props: {},
  data () {
    const market = this.$store.getters['getMarket'];
    return {
      user: JSON.parse( JSON.stringify( this.$store.getters['user/getUserSelected'] ) ),
      valid: false,
      types: [
          { text: i18n.t('user.types.admin'), value: "2"},
          //{ text: i18n.t('admin.views.users.role.agency'), value: "4"},
          { text: i18n.t('user.types.franchise'), value: "1"},
          { text: i18n.t('admin.views.users.role.manager'), value: "3"},
          { text: i18n.t('user.types.consultant'), value: "5"}
        ],
      nameRules: [
                    v => !!v || i18n.t('general.obligatory_name')
                  ],
      phoneRules: [
                    v => v.trim() == '' || v.replace( / /g, '' ) == parseInt( v.replace( / /g, '' ) ) || i18n.t('general.phone_not_correct')
                  ],
      emailRules: [
        v => !!v || i18n.t('general.obligatory_email'),
        v => {
          const domain = market === 'ES' ? 'es.mcd.com' : 'pt.mcd.com';
          const regex = new RegExp(`[a-z0-9!#$%&'*+/=?^_\`{|}~-]+(?:\\.[a-z0-9!#$%&'*+/=?^_\`{|}~-]+)*@${domain}`);
          return regex.test(v) || 'Por favor, introduce un email corporativo';
        }
      ],
      headers: [
          { text: i18n.t('general.name'), value: "name" },
          { text: i18n.t('general.region'), value: "region" },
      ],
      search: "",
      id: -1,
      message_not_found: i18n.t('user.restaurant_not_found'), 
      message_rows_per_page: i18n.t('user.restaurant_rows_per_page'),
      rowsPerPage: [
                        10,
                        20,
                    ],
      pagination: {
        sortBy: false,
        descending: true
      },
    }
  },
  created() {
      var id = ( this.user.id != -1 )? this.user.id : 'add';
      this.$router.push( { name: 'users_edit', params: { id: id } } );

      this.user.active = this.user.active == "1";
  },
  computed: {
      restaurants(){
          var restaurants = JSON.parse( JSON.stringify( ObjectToArray( this.$store.getters['locations/getLocations'] ) ) );
          var self = this;
          console.log( this.user.locations );
          restaurants.sort(function(a,b) {
            function existRestaurant( locations, restaurant ){
              var bFound = false;
              locations.forEach( location => {
                if( location.id == restaurant.id ) {
                  console.log("EXIST");
                  bFound = true;
                }
              });

              return bFound;
            }

            if( existRestaurant( self.user.locations, a ) && !existRestaurant( self.user.locations, b ) ) return -1;
            else if ( existRestaurant( self.user.locations, b ) ) return 1;
            else return 0;
          });
          return restaurants;
      },
      regions(){
        return this.$store.getters['locations/getRegions'];
      },
      selected: {
        get: function(){
            return this.user.locations;
        },
        set: function( location ){
          console.log( location );
          this.user.locations = location;
        }
      }
  },
  methods: {
    back() {
      this.$store.commit('user/setSelectedUser', false);
      this.$router.push( { name: 'users' } );
      window.scrollTo(0,0);
    },
    toggleAll () {
      if (this.selected.length) this.selected = []
      else {
        var restaurants = this.restaurants;
        this.selected = restaurants.slice();
      }
    },
    changeSort (column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    save() {
      if( this.$refs.form_user.validate() ){
          var self = this;
          if (this.user.password){
            this.user.password =  sha256(this.user.password);            
          }
          this.$store.dispatch( 'user/uploadUser', this.user ).then( function(){
              window.scrollTo(0,0);
              self.$store.commit('user/setSelectedUser', false );
              self.$router.push( { name: 'users' } );
              self.$store.dispatch( 'user/loadUsers' );
          });
      }
    },
    filter( items, search, filter ){

      var aItems = [];
      items.forEach( item => {
        if( filter( item.site, search.toLowerCase() ) || filter( this.regions[item.region].name, search.toLowerCase() ) || filter( item.name, search.toLowerCase() ) ){
          aItems.push( item );
        }
      });
      return aItems;
    },
    filterTable( items, search, filter ){

      var aItems = [];
      items.forEach( item => {
        if ( filter( item.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase(), search.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase() ) || filter( item.site, search ) || filter( item.region, search.toLowerCase() ) ) {
            aItems.push( item );
        }
      });
      return aItems;
    }
  }
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  #file {
    max-width: 1200px;
    margin: 0 auto;
    margin-bottom: 50px;
  }

  .back {
    background: url(/img/left-arrow.svg) no-repeat left center;
    text-align: left;
    margin-bottom: 20px;
    padding-left: 25px;
    cursor: pointer;
  }

  .alert {
    background: #dff0f1;
    padding: 15px;
    margin: 15px 0;
    color: #5a6873;
  }
  .container {
    width: 100%;
    overflow: hidden;

    .image {
      width: 40%;
      float: left;
      padding: 0 40px;

      img {
        width: 95%;
      }
    }

    .content {
      width: 100%;
      float: left;
      text-align: left;
      padding: 0 25px;

      .title {
        margin: 10px 0;
        font-size: 20pt;
        font-family: Speedee-Bold;
      }
      .details {
        margin: 20px 0;

        .subtitle {
          font-family: Speedee-Bold;
          color: #bbb;
          margin-bottom: 10px;
        }
        .item {
          font-size: 11pt;

          .label {
            margin-right: 5px;
          }
          .value {
            font-family: Speedee-Bold;
          }
        }
      }

      .buttons {
        margin: 35px 0;

        .bttn{
          width: 100%;
          max-width: 300px;
          overflow: hidden;
          margin-bottom: 5px;
          line-height: 30px;
          cursor: pointer;
          display: block;
          color: #333;

          .icon {
            width: 30px;
            height: 30px;
            background: #ccc;
            display: inline-block;
            float: left;
            overflow: hidden;
          }
          span {
            display: inline-block;
            float: left;
            padding-left: 5px;
            font-size: 11pt;

              &:hover {
                font-family: Speedee-Bold;
              }
          }
          &.download{
            border-top: 2px solid var(--main_color);

            .icon {
              background: url(/img/download.svg) no-repeat center var(--main_color);
              background-size: 18px;
            }
          }
          &.order{
            border-top: 2px solid #ccc;
            .icon {
              background: url(/img/edit.svg) no-repeat center #ccc;
              background-size: 18px;
            }

          }
        }

      }
      .desc {
        font-size: 10pt;
        margin-top: 25px;
        margin-bottom: 5px;
        display: block;
      }
      .url {
        width: 100%;
        padding: 5px;
        font-size: 11pt;
        border-radius: 5px;
        border: 1px solid #ccc;
      }
    }
  }

</style>

